import { Link } from 'react-router';

import { Divider } from '@/components/shared/Divider/Divider.tsx';
import { PageHeading } from '@/components/shared/PageHeading/PageHeading.tsx';
import { appRoutes } from '@/routes/app-routes.ts';

import cn from './styles.module.sass';

export const About = () => {
    return (
        <div className={cn.container}>
            <PageHeading pageName="О приложении" />
            <div className={cn.content}>
                <img src="/images/main/about_logo.svg" alt="" />
                <div className={cn.links}>
                    <Link to={appRoutes.privacyPolicy}>Privacy Policy</Link>
                    <Divider />
                    <a href="/docs/requisites.pdf">Реквизиты</a>
                    <Divider />
                </div>
            </div>
        </div>
    );
};
